<template>
<div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">

        <!--SLIDE-1-->
        <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de conocimientos previos">
            <div class="container-fluid Fondo3Ppal topactivi Fondo-Actividades d-flex align-items-center">
                <div class="container mx-auto">
                    <div class="row ">
                        <div class="col-xl-7 col-lg-5 col-md-12 p-4">
                            <div>
                                <h2 class="text-white">Actividad de conocimientos previos</h2>
                                <h3 class="text-white"><a href="#" class="tooltipurl_titulo" v-b-popover.click.blur.html="tooltip1">Repaso sobre conjuntos numéricos</a></h3>
                                <h5 class="text-white">Tipo de actividad: selección</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 d-none d-xl-block d-lg-block">
                        <p class="text-right mr-3 txtfiguras color1Ppal mt-2">Imagen de <span class="url"><a href="https://www.freepik.es/shurkin-son" target="_blank">@shurkin-son</a></span> en <span class="url"><a href="https://www.freepik.es/foto-gratis/mujer-joven-expresiva-posando_11199410.htm#page=3&query=estudiar&position=28" target="_blank">Freepik</a></span></p>
                    </div>
                </div>
            </div>

           <div class="container mt-4">
                <div class="row">
                    <div class="col-md-12">
                        <h4>Objetivo</h4>
                        <p>Resolver situaciones problemas utilizando los conjuntos numéricos y sus operaciones, a partir de la comprensión e interpretación del lenguaje natural y simbólico.</p>
                        <h4 class="mt-4">Planteamiento</h4>
                        <p>Para cada uno de los enunciados que se presentan a continuación, seleccione la respuesta correcta.</p>
                    </div>
                </div>
            </div> 

            <div class="container-fluid mb-5 pb-4">
                <div class="row">
                    <div class="col-lg-8 col-md-12 offset-lg-2">
                        <div class="swiper-container-2 overflow-hidden">
                            <div class="swiper-wrapper">
                                <!--Slide 1-->
                                <div class="swiper-slide swiper-no-swiping p-3">
                                    <div class="row">
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">1.</b> ¿Cuál de las siguientes proposiciones <b>no</b> es una implicación lógica?</p>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_1" id="checkCP_A" @click="activar($event,1)"></button>
                                                    </div>
                                                    <p>Si 𝑥+3=5, entonces, 𝑥=2.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_1" id="checkCP_B" @click="activar($event,1)"></button>
                                                    </div>
                                                    <p>Si Juan y Pedro tienen la misma edad, entonces, son mellizos.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_1" id="checkCP_C" @click="activar($event,1)"></button>
                                                    </div>
                                                    <p>Juan y Pedro son mellizos y Julián tiene tres años más que Pedro, entonces, Julián es mayor que Juan. </p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_1" id="checkCP_C" @click="activar($event,1)"></button>
                                                    </div>
                                                    <p>Si 𝑥=2𝑦, entonces, 𝑥>𝑦.</p>
                                                </div>
                                            </div>
                                        </div>
                                         <div class="col-lg-6 col-12">
                                            <p v-katex:auto><b class="color3Ppal">2.</b> Sea \(𝐴=\left\{𝑥∈ℕ∕𝑥=2𝑛+1 ∧𝑥&#60;1\right\}\), entonces:</p>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_2" id="checkCP_A" @click="activar($event,2)"></button>
                                                    </div>
                                                    <p>𝑨=∅</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_2" id="checkCP_B" @click="activar($event,2)"></button>
                                                    </div>
                                                    <p>𝑥=3, pues es un número natural impar.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_2" id="checkCP_C" @click="activar($event,2)"></button>
                                                    </div>
                                                    <p>𝑥 representa cualquier número natural menor que 1.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_2" id="checkCP_D" @click="activar($event,2)"></button>
                                                    </div>
                                                    <p>0 ∈ 𝐴</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 d-flex mt-3 justify-content-center">
                                        <button class="d-flex mx-auto BtnPrincipal btn_siguiente">Siguiente</button>
                                    </div>
                                </div>

                                <!--Slide 2-->
                                <div class="swiper-slide swiper-no-swiping p-3">
                                    <div class="row">
                                        <div class="col-xl-6 col-12">
                                            <p v-katex:auto class="mb-0"><b class="color3Ppal">3.</b> Sea \(\frac{a}{b}\) una fracción representada por la siguiente figura:</p>
                                            <img src="recursos/img/FM_U2_T1_slide10_1@4x.png" class="img-fluid d-flex mx-auto mb-1" alt="">
                                            <p v-katex:auto>Una fracción equivalente de \(\frac{a}{b}\) está representada por:</p>
                                            <div class="row">
                                                
                                                <div class="col-lg-2 col-12">
                                                    <div class="row">
                                                        <div class="col-12 d-flex">
                                                            <div>
                                                                <button class="Radiobutton checkCP mr-2 checkCP_3" id="checkCP_A" @click="activar($event,3)"></button>
                                                            </div>
                                                            <p>a</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 d-flex">
                                                            <div>
                                                                <button class="Radiobutton checkCP mr-2 checkCP_3" id="checkCP_B" @click="activar($event,3)"></button>
                                                            </div>
                                                            <p>b</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 d-flex">
                                                            <div>
                                                                <button class="Radiobutton checkCP mr-2 checkCP_3" id="checkCP_C" @click="activar($event,3)"></button>
                                                            </div>
                                                            <p>c</p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 d-flex">
                                                            <div>
                                                                <button class="Radiobutton checkCP mr-2 checkCP_3" id="checkCP_D" @click="activar($event,3)"></button>
                                                            </div>
                                                            <p>d</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-10 col-12">
                                                    <img src="recursos/img/FM_U2_T1_slide10_2@4x.png" class="img-fluid d-flex mx-auto mb-1" alt="">
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">4.</b> Usted va a comprar un par de zapatos que cuestan $140.000, pero en la etiqueta indican que tienen un 40 % de descuento. El precio que debe pagar por dichos zapatos es:</p>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_4" id="checkCP_A" @click="activar($event,4)"></button>
                                                    </div>
                                                    <p>$100.000</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_4" id="checkCP_B" @click="activar($event,4)"></button>
                                                    </div>
                                                    <p>$56.000</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_4" id="checkCP_C" @click="activar($event,4)"></button>
                                                    </div>
                                                    <p>$35.000</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_4" id="checkCP_D" @click="activar($event,4)"></button>
                                                    </div>
                                                    <p>$84.000</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 d-flex mt-3 justify-content-center">
                                        <button class="d-flex mx-3 BtnPrincipal btn_atras">Anterior</button>
                                        <button class="d-flex mx-3 BtnPrincipal btn_siguiente">Siguiente</button>
                                    </div>
                                </div>

                                <!--Slide 3-->
                                <div class="swiper-slide swiper-no-swiping p-3">
                                    <div class="row">
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">5.</b> Sean 𝑥 y 𝑦 dos números naturales, donde 𝑥 &#60; 𝑦 . El enunciado que corresponde a la expresión 𝑦+6=2𝑥 es:</p>
                                             <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_5" id="checkCP_A" @click="activar($event,5)"></button>
                                                    </div>
                                                    <p>El doble del número mayor equivale al número menor aumentado en 6 unidades.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_5" id="checkCP_B" @click="activar($event,5)"></button>
                                                    </div>
                                                    <p>El número más pequeño aumentado en 6 unidades es igual al doble del número más grande.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_5" id="checkCP_C" @click="activar($event,5)"></button>
                                                    </div>
                                                    <p>El número más grande es 6 unidades mayor que el doble del número más pequeño.</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_5" id="checkCP_D" @click="activar($event,5)"></button>
                                                    </div>
                                                    <p>El número más grande es igual al doble del pequeño aumentado en 6 unidades.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">6.</b> En un día normal de trabajo, Juan se levanta a las 6:00 a. m. y se acuesta a las 10:00 p. m. Si en esa jornada Juan dedica 5/8 del tiempo a trabajar, en esa misma jornada, ¿cuánto tiempo invierte Juan en su descanso?</p>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_6" id="checkCP_A" @click="activar($event,6)"></button>
                                                    </div>
                                                    <p>3 horas</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_6" id="checkCP_B" @click="activar($event,6)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(\frac{10}{16}\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_6" id="checkCP_C" @click="activar($event,6)"></button>
                                                    </div>
                                                    <p>5 horas</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_6" id="checkCP_D" @click="activar($event,6)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(\frac{3}{8}\) de su jornada</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 d-flex mt-3 justify-content-center">
                                        <button class="d-flex mx-3 BtnPrincipal btn_atras">Anterior</button>
                                        <button class="d-flex mx-3 BtnPrincipal btn_siguiente">Siguiente</button>
                                    </div>
                                </div>

                                <div class="swiper-slide swiper-no-swiping p-3">
                                    <div class="row">
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">7.</b> Suponga que usted trabaja en una pizzería y un cliente le hace el siguiente pedido: “una pizza de jamón, media pizza hawaiana, una pizza y media de champiñones, tres pizzas y media de pepperoni y tres pizzas y media de salami”. Si todas las pizzas tienen igual tamaño y el mismo precio, la operación que no representa el número de pizzas a facturar es:</p>
                                             <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_7" id="checkCP_A" @click="activar($event,7)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(11\times\left(\frac{1}{2}\right)\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_7" id="checkCP_B" @click="activar($event,7)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(2\left(1+\frac{1}{2}\right)+\frac{3}{2}+\frac{7}{2}\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_7" id="checkCP_C" @click="activar($event,7)"></button>
                                                    </div>
                                                     <p v-katex:auto>\(1+\frac{1}{2}+1+\frac{1}{2}+\frac{1}{2}+\frac{1}{2}+\frac{1}{2}+3+\frac{1}{2}\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_7" id="checkCP_D" @click="activar($event,7)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(5+6\left(\frac{1}{2}\right)\)</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">8.</b> Seleccione entre las opciones el valor que debe tomar la 𝑥 para que la siguiente proposición sea verdadera:</p>
                                            <p class="text-center">3 𝑥−4=𝑥−8</p>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_8" id="checkCP_A" @click="activar($event,8)"></button>
                                                    </div>
                                                    <p>𝑥=2</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_8" id="checkCP_B" @click="activar($event,8)"></button>
                                                    </div>
                                                    <p>𝑥=1</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_8" id="checkCP_C" @click="activar($event,8)"></button>
                                                    </div>
                                                    <p>𝑥=−2</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_8" id="checkCP_D" @click="activar($event,8)"></button>
                                                    </div>
                                                    <p>No existe</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                    <div class="col-12 d-flex mt-3 justify-content-center">
                                        <button class="d-flex mx-3 BtnPrincipal btn_atras">Anterior</button>
                                        <button class="d-flex mx-3 BtnPrincipal btn_siguiente">Siguiente</button>
                                    </div>
                                </div>

                                <div class="swiper-slide swiper-no-swiping p-3">
                                    <div class="row">
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">9.</b> Considere la siguiente figura:</p>
                                            <img src="recursos/img/FM_U2_T1_slide11_1@4x.png" class="img-fluid d-flex mx-auto mb-1" alt="">
                                            <p>En términos de porcentajes, el área sombreada en color gris está representada por:</p>
                                             <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_9" id="checkCP_A" @click="activar($event,9)"></button>
                                                    </div>
                                                    <p>40 %</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_9" id="checkCP_B" @click="activar($event,9)"></button>
                                                    </div>
                                                    <p>140 %</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_9" id="checkCP_C" @click="activar($event,9)"></button>
                                                    </div>
                                                    <p>20 %</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_9" id="checkCP_D" @click="activar($event,9)"></button>
                                                    </div>
                                                    <p>10 %</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-12">
                                            <p><b class="color3Ppal">10.</b> En la figura anterior (pregunta 9), la porción del área sombreada en color morado está dada por:</p>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_10" id="checkCP_A" @click="activar($event,10)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(\frac{4}{5}\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_10" id="checkCP_B" @click="activar($event,10)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(\frac{8}{10}\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_10" id="checkCP_C" @click="activar($event,10)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(\frac{4}{10}\)</p>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12 d-flex">
                                                    <div>
                                                        <button class="Radiobutton checkCP mr-2 checkCP_10" id="checkCP_D" @click="activar($event,10)"></button>
                                                    </div>
                                                    <p v-katex:auto>\(\frac{8}{5}\)</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                    <div class="col-12 mt-3">
                                        <div v-if="faltantes" class="alert alert-danger text-center" role="alert">
                                            ¡Debe terminar toda la actividad!
                                        </div>
                                    </div>
                                    <div class="col-12 d-flex mt-3 justify-content-center">
                                        <button class="d-flex mx-3 BtnPrincipal btn_atras">Anterior</button>
                                        <button @click="comprobarRespuestas()" class="btn BtnPrincipal mx-3">Comprobar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modales :tituloResultado="tituloResultado" :descripcionResultado="descripcionResultado" :imgURL="imgURL"/>
</div>
</template>

<script>
import {SwiperController} from '../assets/RecursosITM/js/Swiper'
import Modales from '@/components/Modales'
export default {

    name: 'ConocimientosPrevios',

	components: {
      Modales
	},

	data() {
        return {
            tooltip1: "<p class='text-left'>El ejercicio n.° 7 de esta actividad fue adaptado de la siguiente referencia:<br>Vallejo-Nágera, A. (1998). <em>¿Odias las matemáticas?</em> (2ª ed.). Ediciones Martínez Roca.</p>",
            
            respuestasEstablecidasCP: ['B','A','B','D','C','D','A','C','C','D'],
            respuestasDadasCP: [],
            
            faltantes: false,
            acertadas: 0,
          
            imgURL: '',
            tituloResultado: '',
            descripcionResultado: '',
        }
    },
    
    methods: {
        activar: function (event, numPregunta) {

            let opcionElegida = event.target.id.split("_")[1];
            let elementosGrupo = document.querySelectorAll(".checkCP_" + numPregunta);

            elementosGrupo.forEach(element => {
                element.classList.remove("active", "i-check");
            });
            event.target.classList.add("active", "i-check");

            this.respuestasDadasCP.push(opcionElegida);
        },
        comprobarRespuestas: function(){

            this.faltantes=false;
            this.acertadas=0;

            //Evaluando faltantes
            if(this.respuestasDadasCP.length < 10){
                this.faltantes=true;
                return;
            }

            for(let i=0; i < this.respuestasEstablecidasCP.length; i++){
                if(this.respuestasEstablecidasCP[i] == this.respuestasDadasCP[i]){
                    this.acertadas++;
                }
            }

            if(this.acertadas >= 8){
                this.imgURL = 'recursos/img/Correcto.png'
                this.tituloResultado = '¡Muy bien!'
                this.descripcionResultado="<p>Ha logrado resolver situaciones problemas utilizando los conjuntos numéricos y sus operaciones.</p>";
            }else{
                this.imgURL = 'recursos/img/Incorrecto.png'
                this.tituloResultado = '¡Intente de nuevo!'
                this.descripcionResultado = "<p>Usted puede mejorar su resultado al resolver situaciones problemas utilizando los conjuntos numéricos y sus operaciones.</p>";
            }

            //Mostramos modal
            this.$root.$emit("bv::show::modal","modal-resultadosActividades");

        }
        
        
        
    },

    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title // Cambiar el título de la página
    },

}
</script>